module.exports = __webpack_public_path__ + "static/media/cont-phone1cfa5fc0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/cont-phone.svg
// module id = 1226
// module chunks = 0